
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {MonitoringService} from './app/services/logging.service';
import {EnvService} from './app/models/env.service';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {
    const monitoringService = new MonitoringService(new EnvService());
    monitoringService.logException(err);
  });
